import Image from 'next/image'
import type { ReactNode } from 'react'

import S from './LeaderboardBackground.module.scss'

const ASSETS = '/assets/leaderboard'

type LayerProps = {
  src: string
  width: number
  height: number
  className: string
}

const Layer = ({ src, width, height, className }: LayerProps) => (
  <Image
    src={`${ASSETS}/${src}`}
    alt=""
    width={width}
    height={height}
    className={className}
    unoptimized
  />
)

/** Podium hero of the global leaderboard (Figma "Leaderboard BG"). */
const LeaderboardBackground = ({
  title,
  children
}: {
  title: string
  /** Rendered under the title (the Fans / Clubs segments). */
  children?: ReactNode
}) => (
  <div className={S.hero}>
    <div className={S.backdrop} aria-hidden>
      <div className={S.stage1440}>
        <Layer src="bg-rays.svg" width={6600} height={111} className={S.rays} />
        <Layer
          src="bg-horizontals.svg"
          width={1440}
          height={67}
          className={S.horizontals}
        />
        <div className={S.vignette} />
        <Layer
          src="bg-podium-1440.svg"
          width={425}
          height={127}
          className={S.podium}
        />
        <Layer
          src="bg-light.svg"
          width={538}
          height={594}
          className={S.light}
        />
        <Layer
          src="bg-top-pattern-1440.svg"
          width={1440}
          height={281}
          className={S.topPattern}
        />
      </div>
      <div className={S.stage960}>
        <Layer src="bg-rays.svg" width={6600} height={111} className={S.rays} />
        <Layer
          src="bg-horizontals.svg"
          width={1440}
          height={67}
          className={S.horizontals}
        />
        <div className={S.vignette} />
        <Layer
          src="bg-podium-960.svg"
          width={349}
          height={106}
          className={S.podium}
        />
        <Layer
          src="bg-light.svg"
          width={538}
          height={594}
          className={S.light}
        />
        <Layer
          src="bg-top-pattern-960.svg"
          width={1020}
          height={199}
          className={S.topPattern}
        />
      </div>
      <Layer src="bg-390.svg" width={390} height={320} className={S.stage390} />
    </div>

    <div className={S.content}>
      <h1 className={S.title}>{title}</h1>
      {children}
    </div>
  </div>
)

export default LeaderboardBackground
